import { Skeleton } from 'components/common/skeleton';
import PropTypes from 'prop-types';
function SkeletonCartMobileForm({ extraClass }) {
    return (
        <div
            className="cart-mobile-form ab-skeleton-cart-form"
            style={{ marginTop: '20px', width: '100%' }}
        >
            <div className="ab-column">
                <div className="ab-body-innerMain">
                    <form style={{ display: 'flex', width: '100%' }}>
                        <div className="ab-book-form-right-wrapper">
                            <div
                                className="ab-body-main ab-cart-form-overf"
                                style={{ overflow: 'hidden' }}
                            >
                                <div
                                    className="ab-cart-whitebox ab-p-10"
                                    style={{ minHeight: '280px' }}
                                >
                                    <div className="ab-cart-whitebox-big-title ab-bf-black">
                                        <Skeleton
                                            width={'100%'}
                                            height={25}
                                            mb={10}
                                        />
                                    </div>

                                    <div className="ab-booking-form">
                                        <div className="ab-input-field-cnt ab-mb-10">
                                            <div className=" ab-input-cnt">
                                                <label className="ab-input-label">
                                                    <Skeleton
                                                        width={'50%'}
                                                        height={20}
                                                    />
                                                </label>
                                                <Skeleton
                                                    width={'100%'}
                                                    height={39}
                                                />
                                            </div>
                                            <div className=" ab-input-cnt">
                                                <label className="ab-input-label">
                                                    <Skeleton
                                                        width={'50%'}
                                                        height={20}
                                                    />
                                                </label>
                                                <Skeleton
                                                    width={'100%'}
                                                    height={39}
                                                />
                                            </div>
                                        </div>

                                        <div className="ab-input-field-cnt ab-mb-10">
                                            <div className=" ab-input-cnt">
                                                <label className="ab-input-label">
                                                    <Skeleton
                                                        width={'50%'}
                                                        height={20}
                                                    />
                                                </label>
                                                <Skeleton
                                                    width={'100%'}
                                                    height={39}
                                                />
                                            </div>
                                            <div className=" ab-input-cnt">
                                                <label className="ab-input-label">
                                                    <Skeleton
                                                        width={'50%'}
                                                        height={20}
                                                    />
                                                </label>
                                                <div className={`ab-input`}>
                                                    <Skeleton
                                                        width={'100%'}
                                                        height={39}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="ab-input-field-cnt ab-mb-10">
                                            <div className=" ab-input-cnt">
                                                <label className="ab-input-label">
                                                    <Skeleton
                                                        width={'50%'}
                                                        height={20}
                                                    />
                                                </label>
                                                <Skeleton
                                                    width={'100%'}
                                                    height={39}
                                                />
                                            </div>
                                        </div>

                                        <div className="ab-input-field-cnt ab-mb-10">
                                            <div className=" ab-input-cnt">
                                                <label className="ab-input-label">
                                                    <Skeleton
                                                        width={'50%'}
                                                        height={20}
                                                    />
                                                </label>
                                                <Skeleton
                                                    width={'100%'}
                                                    height={39}
                                                />
                                            </div>
                                        </div>

                                        <div
                                            className="ab-input-field-cnt ab-mb-10"
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'flex-start',
                                            }}
                                        >
                                            <Skeleton
                                                width={'50%'}
                                                height={20}
                                                mb={10}
                                            />
                                            <div className=" ab-input-cnt">
                                                <Skeleton
                                                    width={'100%'}
                                                    height={106}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className=""
                                        style={{
                                            minHeight: '330px',
                                            marginBottom: '2px',
                                        }}
                                    >
                                        <div className="ab-cart-pay-title">
                                            <Skeleton
                                                width={'30%'}
                                                height={36}
                                            />
                                        </div>
                                        <div className="ab-cart-pay-options">
                                            <div className="ab-payment-options">
                                                <div
                                                    className={`ab-cart-radio-option`}
                                                >
                                                    <Skeleton
                                                        width={99}
                                                        height={31}
                                                    />
                                                </div>
                                                <div
                                                    className={`ab-cart-radio-option `}
                                                >
                                                    <Skeleton
                                                        width={99}
                                                        height={31}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="ab-whitebox-header">
                                                <div className="first-part">
                                                    <Skeleton
                                                        width={99}
                                                        height={40}
                                                    />
                                                </div>
                                                <div className="second-part">
                                                    <Skeleton
                                                        width={'100%'}
                                                        height={40}
                                                        minWidth={240}
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                className={`ab-whitebox-body ab-p-10 ab-cart-card-wrapper `}
                                                style={{
                                                    cursor: 'pointer',
                                                }}
                                            ></div>
                                        </div>
                                        <div>
                                            <hr />

                                            <label
                                                className="ab-pt-10 ab-pb-10 ab-booking-form-terms"
                                                style={{
                                                    display: 'flex',
                                                    cursor: 'pointer',
                                                }}
                                                id="form-checkbox"
                                            >
                                                <Skeleton
                                                    width={'100%'}
                                                    height={62}
                                                />
                                            </label>

                                            <hr />
                                            <div
                                                className="mail-send-info ab-pt-10 ab-pb-10"
                                                style={{
                                                    paddingLeft: '2px',
                                                }}
                                            >
                                                <Skeleton
                                                    width={'100%'}
                                                    height={59}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="ab-booking-form-button-wrapper">
                                    <div className="">
                                        <Skeleton width={'100%'} height={43} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

SkeletonCartMobileForm.propTypes = {
    extraClass: PropTypes.string,
};

export default SkeletonCartMobileForm;
